import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { SponsoredHeader } from './components/SponsoredHeader';
import { Hero } from './components/Hero';
import { TextBlock } from './components/Typography';
import { ChapterBanner } from './components/ChapterBanner';
import { FadeIn } from './components/FadeIn';
import { PullQuote } from './components/PullQuote';
import { NeuroscienceCallout } from './components/NeuroscienceCallout';
import { WeekCards } from './components/WeekCards';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream text-navy font-serif selection:bg-amber/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SponsoredHeader data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />

        <article data-id="element-5">
          <FadeIn data-id="element-6">
            <TextBlock data-id="element-7">
              <p data-id="element-8">The first time I tried to quit I was 20 years old.</p>
              <p data-id="element-9">
                I had read something about NoFap on a forum. The post said that
                if you lasted 30 days you became "a different man." More energy.
                More confidence. Women would notice.
              </p>
              <p data-id="element-10">I made it to day 11.</p>
              <p data-id="element-11">Then day 8. Then day 3.</p>
              <p data-id="element-12">
                After a while I stopped counting. Not because I had won — but
                because counting the days had become another way of thinking
                about it all the time.
              </p>
              <p data-id="element-13">
                Fourteen years. That is how long it took me to understand I was
                using the wrong tool.
              </p>
            </TextBlock>
          </FadeIn>

          <ChapterBanner src="https://cdn.magicpatterns.com/uploads/1tRE3iL5qJd5yYT8P6teYH/imagen_2.png" alt="Tired man at desk with laptop in dim room" title='This Was Not What You Picture When You Hear "Addiction"' data-id="element-14" />
          <FadeIn data-id="element-15">
            <TextBlock data-id="element-16">
              <p data-id="element-17">
                I had a job. A good job. An apartment. Relationships. From the
                outside everything looked fine.
              </p>
              <p data-id="element-18">
                But there was a version of me that showed up after 11 PM. When
                everyone was asleep. When the screen was the only thing lit in
                the room.
              </p>
              <p data-id="element-19">
                And the strangest part — the thing that was hardest to admit —
                was that I did not enjoy it. Not really. It was more like an
                automatic protocol. Something the brain executed on its own
                before I could decide anything.
              </p>
              <p data-id="element-20">Like someone else taking control for a few minutes.</p>
              <p data-id="element-21">
                And then came that brutal clarity in the seconds after. That
                internal voice asking the same question:
              </p>
              <p className="italic font-bold" data-id="element-22">Why can't I just stop?</p>
            </TextBlock>
          </FadeIn>

          <ChapterBanner src="https://cdn.magicpatterns.com/uploads/nczitS5d7m5kwQhsWpx12p/imagen_3_-_copia.png" alt="Father holding newborn baby in hospital, warm intimate light" title="The Night Everything Changed" data-id="element-23" />
          <FadeIn data-id="element-24">
            <TextBlock data-id="element-25">
              <p data-id="element-26">My daughter was born in March 2022.</p>
              <p data-id="element-27">
                I remember being in the hospital. Her in my arms. My partner
                asleep after 18 hours of labor.
              </p>
              <p data-id="element-28">
                And in that moment — with her right there — I had the most
                uncomfortable thought of my life:
              </p>
              <p className="italic font-bold" data-id="element-29">
                What kind of man is going to raise her?
              </p>
              <p data-id="element-30">
                It was not guilt. It was something deeper than that. It was a
                real question. Urgent. And I knew I could not keep answering it
                with "I'll try again next week."
              </p>
              <p data-id="element-31">
                That night I searched for something different. Not NoFap. Not
                blockers. Not streak apps.
              </p>
              <p data-id="element-32">
                Something that would actually explain why the brain does this.
                And why willpower never works to stop it.
              </p>
            </TextBlock>
          </FadeIn>

          <ChapterBanner src="https://cdn.magicpatterns.com/uploads/9E6AUHVi6R8TYrvhHwLbZS/imagen_4.png" alt="Open book lit by a lamp in a dark library" title="What I Found Changed Everything" data-id="element-33" />
          <FadeIn data-id="element-34">
            <TextBlock data-id="element-35">
              <p data-id="element-36">I found UNHOOKED three weeks later.</p>
              <p data-id="element-37">
                I did not arrive looking for a book. I arrived looking for an
                explanation. And that is exactly what I found first — before any
                promise or protocol.
              </p>
              <p data-id="element-38">
                The book starts by explaining something nobody had told me in 14
                years:
              </p>

              <PullQuote data-id="element-39">
                The problem is not that you are weak. The problem is that you
                are using System 2 of the brain — the logical, rational part —
                to try to control System 1 — the automatic, emotional part. It
                is like trying to stop a car going 75 miles per hour by pushing
                the steering wheel with your hands.
              </PullQuote>

              <p data-id="element-40">I read that line three times.</p>
              <p data-id="element-41">
                Not because it was poetic. But because it was the first time
                what I was living made sense.
              </p>
            </TextBlock>
          </FadeIn>

          <div className="max-w-[680px] mx-auto px-5 sm:px-6" data-id="element-42">
            <NeuroscienceCallout data-id="element-43" />
          </div>

          <ChapterBanner src="https://cdn.magicpatterns.com/uploads/59v2nE4xc16qwU1nUfaPaV/imagen_5.png" alt="Glowing blue neural network on dark background" title="Why Your Brain Is Not Your Enemy" data-id="element-44" />
          <FadeIn data-id="element-45">
            <TextBlock data-id="element-46">
              <p data-id="element-47">The book did not ask me to stop.</p>
              <p data-id="element-48">That was the first thing that surprised me.</p>
              <p data-id="element-49">
                No rules. No streak. No "if you fail, restart from zero." Just
                one instruction:
              </p>
              <p className="italic font-bold" data-id="element-50">
                Read. Let what you read change how you see the situation.
              </p>
              <p data-id="element-51">What I learned in the following chapters was this:</p>
              <p data-id="element-52">
                The brain does not want pornography. The brain wants dopamine.
                And porn is simply the fastest path it learned to get it.
              </p>
              <p data-id="element-53">But here is the key — and this changed everything for me:</p>
              <p className="font-bold" data-id="element-54">
                The craving for dopamine and real pleasure are two completely
                separate systems.
              </p>
              <p data-id="element-55">
                Scientist Kent Berridge proved this decades ago. The wanting —
                the compulsive urge — is controlled by dopamine. The liking —
                the real pleasure — is controlled by opioids.
              </p>
              <p data-id="element-56">
                When you watch porn you are not enjoying anything. You are
                following a chemical instruction.
              </p>
              <p data-id="element-57">
                Once you understand that — really understand it — something
                switches off.
              </p>
            </TextBlock>
          </FadeIn>

          <ChapterBanner src="https://cdn.magicpatterns.com/uploads/sjixqFPvnZWt9nDmtmHehy/imagen_6.png" alt="Open notebook with calendar checkmarks and pen" title="The 21-Day Protocol" data-id="element-58" />
          <FadeIn data-id="element-59">
            <TextBlock data-id="element-60">
              <p data-id="element-61">
                UNHOOKED has a 21-day protocol. But it is not what you think.
              </p>
              <p data-id="element-62">
                It is not "do not watch porn for 21 days." It is a process of 13
                specific exercises designed to reprogram how the brain processes
                the stimulus.
              </p>
            </TextBlock>
          </FadeIn>

          <div className="max-w-5xl mx-auto px-5 sm:px-6" data-id="element-63">
            <WeekCards data-id="element-64" />
          </div>

          <FadeIn data-id="element-65">
            <TextBlock data-id="element-66">
              <PullQuote data-id="element-67">
                On day 9 I noticed I had not thought about it all day. I was not
                avoiding it. It simply was not there.
                <span className="block text-sm font-sans text-navy/60 mt-4 not-italic" data-id="element-68">
                  — Marcus, Week 2 of the protocol
                </span>
              </PullQuote>
            </TextBlock>
          </FadeIn>

          <ChapterBanner src="https://cdn.magicpatterns.com/uploads/aYUjxcNja2nn81Ze6YgWcD/imagen_7.png" alt="Couple laughing together on a couch in warm lamplight" title="What Came Back When the Noise Left" data-id="element-69" />
          <FadeIn data-id="element-70">
            <TextBlock data-id="element-71">
              <p data-id="element-72">It has been 14 months.</p>
              <p data-id="element-73">
                I do not count days. I do not have an active streak in any app.
                I do not think of it as "something I am avoiding."
              </p>
              <p data-id="element-74">It is simply a part of my life that no longer exists.</p>
              <p data-id="element-75">
                What surprised me most was not the absence of the habit. It was
                what appeared when the noise disappeared.
              </p>
              <p data-id="element-76">
                Real focus. Not the kind you fake in meetings — genuine
                concentration. The ability to be present with my daughter
                without my mind somewhere else. A relationship with my partner
                where for the first time in years there is no invisible glass
                wall between us.
              </p>
              <p data-id="element-77">And something harder to describe:</p>
              <p className="italic font-bold" data-id="element-78">
                The feeling of being the same man in public and in private.
              </p>
              <p data-id="element-79">
                That silent double life I had been carrying since I was 20 years
                old — it is gone.
              </p>
            </TextBlock>
          </FadeIn>
        </article>

        <Testimonials data-id="element-80" />
        <CTASection data-id="element-81" />
      </main>

      <Footer data-id="element-82" />
    </div>;
}